import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';
import { useAuth } from '../App';

// Blocking dialog when an admin-issued one-time password must be replaced.
export const ForcePasswordChange = () => {
  const { user, checkAuth, logout, language, API } = useAuth();
  const L = (en, de) => (language === 'de' ? de : en);
  const [cur, setCur] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [saving, setSaving] = useState(false);
  if (!user || !user.must_change_password) return null;
  const valid = pw.length >= 6 && pw === pw2 && cur;
  const save = async () => {
    setSaving(true);
    try {
      await API.put('/auth/change-password', { current_password: cur, new_password: pw });
      toast.success(L('Password changed', 'Passwort geändert'));
      await checkAuth();
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : L('Error', 'Fehler'));
    } finally { setSaving(false); }
  };
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-sm [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} data-testid="force-password-dialog">
        <DialogHeader>
          <DialogTitle>{L('Choose your own password', 'Eigenes Passwort wählen')}</DialogTitle>
          <DialogDescription>{L('You signed in with a one-time password. Please set your own password now.', 'Du hast dich mit einem Einmal-Passwort angemeldet. Bitte lege jetzt dein eigenes Passwort fest.')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Input type="password" placeholder={L('One-time password', 'Einmal-Passwort')} value={cur} onChange={(e) => setCur(e.target.value)} data-testid="force-pw-current" />
          <Input type="password" placeholder={L('New password (min. 6)', 'Neues Passwort (mind. 6 Zeichen)')} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="force-pw-new" />
          <Input type="password" placeholder={L('Repeat new password', 'Neues Passwort wiederholen')} value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="force-pw-repeat" />
          {pw2 && pw !== pw2 && <p className="text-xs text-red-600">{L('Passwords do not match', 'Passwörter stimmen nicht überein')}</p>}
          <div className="flex gap-3 pt-1">
            <Button variant="outline" className="flex-1" onClick={logout} data-testid="force-pw-logout">{L('Log out', 'Abmelden')}</Button>
            <Button className="flex-1 bg-emerald-500 hover:bg-emerald-600 text-white font-bold" disabled={!valid || saving} onClick={save} data-testid="force-pw-save">{L('Save', 'Speichern')}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ForcePasswordChange;
